import styled from 'styled-components';

const Container = styled.div`
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  margin: auto;
  height: fit-content;
  max-height: 90vh;
  width: 100% !important;
  max-width: 1024px;
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  // background: red;
  background-color: ${({ theme }) => theme.palette.gray.light};
  // width: 44.74vw;
  box-shadow: 0 0 6px 0px rgba(0, 0, 0, 0.3);

  &:focus {
    outline: 0;
  }
`;

export default Container;
